import React from 'react';
import PropTypes from 'prop-types';
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import graphql from "babel-plugin-relay/macro";
import {useFragment} from "react-relay";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {useUser} from "../../../hooks/useUser";
import NewFacilityVersionModal from "./NewFacilityVersionModal";
import EditFacilityVersionModal from "./EditFacilityVersionModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import {useTableModals} from "../../../hooks/useTableModals";

const cols = [
    {accessor: 'name', Header: 'Name'},
    {accessor: 'nickName', Header: 'Nickname'},
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor: 'effectiveTo', Header: 'Effective To', Cell: DateCell}
]
const FacilityVersions = ({versions, facilityId}) => {
    const deleteMutation = graphql`
        mutation FacilityVersionsDeleteMutation($id: ID!) {
            deleteNode(input: {id: $id}) {
                deletedNodeId @deleteRecord
                owner {
                    ... on Facility {
                        id
                        versions {
                            id
                        }
                        applicableVersion {
                            id
                            name
                            nickName
                        }}}}}`
    const data = useFragment(graphql`
        fragment FacilityVersions_Versions on FacilityVersion @relay(plural: true) {
            id
            name
            nickName,
            effectiveFrom
            effectiveTo
        }
    `, versions);
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(cols, "Facility.Update", "Facility.Update");
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Versions"}
                                         table
                                         showNew={hasPermission("Facility.Update")}/>
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table/>
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewFacilityVersionModal showModal={newModal.showModal}
                                     onClose={newModal.onClose}
                                     facilityId={facilityId}
            />
            {selected && <EditFacilityVersionModal showModal={editModal.showModal}
                                                   onClose={editModal.onClose}
                                                   selectedVersion={selected}
            />}
            {selected && <DeleteModal mutation={deleteMutation}
                                      onClose={deleteModal.onClose}
                                      thingToDelete={"Version"}
                                      showModal={deleteModal.showModal}
                                      id={selected.id}
            >
                <p>This action cannot be undone</p>
            </DeleteModal>}
        </>
    )
}
FacilityVersions.propTypes = {
    versions: PropTypes.array.isRequired,
    facilityId: PropTypes.string.isRequired
}
export default FacilityVersions